import * as React from 'react';
import { ComposeViewState } from 'owa-mail-compose-store';
import ComposeCommandingBar from './ComposeCommandingBar';
import FullCompose from './FullCompose';

const styles = require('./ProjectionCompose.scss');

export default function ProjectionCompose({ viewState }: { viewState: ComposeViewState }) {
    return (
        <div className={styles.projectionCompose}>
            <div className={styles.commandBar}>
                <ComposeCommandingBar composeViewState={viewState} />
            </div>
            <div className={styles.readingPane}>
                <FullCompose viewState={viewState} />
            </div>
        </div>
    );
}
